import React from 'react';
import { SocietyChip } from './SocietySwitcher';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useAuth } from '../AuthContext';
import HeaderProfile from './HeaderProfile';
import './PageHeader.css';

/**
 * The one page header. Three columns with equal 40px edges, so the title stays
 * optically centred whatever sits either side of it:
 *
 *   [ back ]        Title / SOCIETY        [ avatar ]
 *
 * `backTo` is the parent screen in the menu tree, not the browser's history —
 * a back arrow that lands somewhere different depending on how you arrived is
 * the thing that made navigation feel random. Pass `backTo={-1}` on screens
 * genuinely reached from anywhere (the profile), and omit it entirely on the
 * bottom-nav roots, which have no parent.
 *
 * `onBack` changes what the arrow DOES while leaving it looking the same. It is
 * for screens sitting below one of those `backTo={-1}` pages: a back that
 * pushes and a back that pops cannot face each other without looping, so those
 * screens pop as well — see `hooks/useParentBack`. Pass `backTo` alongside it,
 * as the fallback destination and so the arrow still renders.
 */
const PageHeader = ({ title, subtitle, backTo, backLabel = 'Back', onBack }) => {
  const navigate = useNavigate();
  const { currentSociety } = useAuth();
  const sub = subtitle !== undefined ? subtitle : currentSociety?.name;

  return (
    <header className="appbar">
      {backTo !== undefined || onBack ? (
        <button
          type="button"
          className="appbar-action"
          onClick={onBack || (() => navigate(backTo))}
          aria-label={backLabel}
        >
          <FiArrowLeft size={21} />
        </button>
      ) : (
        <div className="appbar-action" aria-hidden="true" />
      )}

      <div className="appbar-title">
        <h1 className="appbar-heading">{title}</h1>
        {/* No subtitle of its own: the society, as the switchable chip. */}
        {subtitle !== undefined
          ? (sub && <div className="appbar-sub">{sub}</div>)
          : (currentSociety && <div className="appbar-sub appbar-sub--chip"><SocietyChip variant="header" /></div>)}
      </div>

      <div className="appbar-action appbar-profile">
        <HeaderProfile />
      </div>
    </header>
  );
};

export default PageHeader;
